module.exports = __webpack_public_path__ + "static/media/PetrifiedPaper.1c71ab22.glb";